import { PageLocatorMap } from '../types/PageLocatorMap';

export const mailCodeActivationPage = {
  alert: {
    error: 'mail-code-activation-page.alert.error',
  },
  footer: {
    root: 'mail-code-activation-page.footer.root',
  },
  form: {
    emailInput: 'mail-code-activation-page.form.email-input',
    emailInputError: 'mail-code-activation-page.form.email-error',
    firstNameInput: 'mail-code-activation-page.form.first-name-input',
    firstNameInputError: 'mail-code-activation-page.form.first-name-error',
    h1: 'mail-code-activation-page.form.heading1',
    h2: 'mail-code-activation-page.form.heading2',
    lastNameInput: 'mail-code-activation-page.form.last-name-input',
    lastNameInputError: 'mail-code-activation-page.form.last-name-error',
    phoneInput: 'mail-code-activation-page.form.phone-input',
    phoneInputError: 'mail-code-activation-page.form.phone-error',
    privacyLink: 'mail-code-activation-page.form.privacy-link',
    reviewsLink: 'mail-code-activation-page.form.reviews-link',
    root: 'mail-code-activation-page.form.root',
    smsOptInCheckbox: 'mail-code-activation-page.form.sms-opt-in-checkbox',
    smsOptInCheckboxError: 'mail-code-activation-page.form.sms-opt-in-error',
    submitButton: 'mail-code-activation-page.form.submit-button',
    termsLink: 'mail-code-activation-page.form.terms-link',
  },
} as const satisfies PageLocatorMap;
